<div class="flex flex-col">
  <select class="select-default" (change)="handleRegionChange($event)">
    @if (allowNoSelection) {
      <option value="" disabled [selected]="!selectedRegion">
        {{ 'Select a Region' }}
      </option>
    }

    @for (region of regionService.supportedRegions; track region) {
      <option
        [selected]="region.id === selectedRegion"
        [value]="region.id">
        {{ region.displayName }}
      </option>
    }
  </select>
</div>
